import styled from 'styled-components';

export const PastOrderTotalHR = styled.hr`
    margin-top: 0;
    margin-bottom: 0;
`